module.exports = {"141027100":"天坛镇","141027101":"响水河镇","141027200":"张庄乡","141027201":"东张乡","141027202":"槐埝乡","141027203":"北王乡","141027204":"北韩乡","141027205":"米家垣乡","141027206":"寨圪塔乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141027.json
// module id = 368
// module chunks = 0